var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 69"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#134A81",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 2.5,
    d: "M50.148 47.944c-2.44 0-4.622.979-6.291 2.512L20.97 36.915c.16-.75.29-1.501.29-2.284 0-.784-.13-1.534-.29-2.285l22.63-13.41c1.733 1.63 4.012 2.642 6.548 2.642 5.329 0 9.63-4.372 9.63-9.789S55.477 2 50.148 2c-5.328 0-9.63 4.372-9.63 9.79 0 .782.129 1.533.29 2.283l-22.63 13.411c-1.734-1.631-4.013-2.643-6.548-2.643-5.329 0-9.63 4.373-9.63 9.79 0 5.416 4.301 9.789 9.63 9.789 2.535 0 4.814-1.012 6.548-2.643L41.032 55.35a9.374 9.374 0 00-.257 2.12c0 5.254 4.205 9.529 9.373 9.529 5.168 0 9.373-4.275 9.373-9.528 0-5.254-4.205-9.528-9.373-9.528h0z"
  })));
}
export default SvgSharing;